import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Button,
  Popover,
  Collapse,
  Checkbox,
  Skeleton,
  TablePagination,
} from "@mui/material";
import { isMobile } from "../../globalStyles/mobile";
import Pagination from "../pagination";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { styled, useTheme } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import InventoryDetailsModal from "../inventory-details-modal";
import OrderTrackingIcon from "../../globalStyles/icons/order-tracking-icon.js";
import { useNavigate } from "react-router-dom";
import Hover from "@mui/material/Tooltip";
import FilterModal from "../filterModal/index.js";
import { inventoryService } from "../../utils/services/inventoryService.js";
import { lotService } from "../../utils/services/lotService.js";
import ForecastIcon from "../../globalStyles/icons/forecast-icon.js";
import TableHeader from "../table-header/index.js";
import ForecastHistoryModal from "../forecast-history-modal";
import { toast } from "react-toastify";
import { staticDataService } from "../../utils/services/static-data.service.js";
import { useForecast } from "../../context/forecastContext";
import { useLostSales } from "../../context/lostSalesContext";
import { formatDate } from "../../utils/formatDate";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    border: "1px solid var(--border-color)",
    padding: "6px",
    color: "var(--text-tertiary)",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "6px",
    color: "var(--text-secondary)",
    borderColor: "var(--border-color)",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme, isExpandable }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: isExpandable ? "var(--bg-highlight)" : "var(--row-bg-odd)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: isExpandable
      ? "var(--bg-highlight)"
      : "var(--row-bg-even)",
    border: "1px solid var(--border-color)",
  },

  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));

const DropskipToolTableCell = ({
  x,
  handleTrackInventory,
  handleOpenForecastHistory,
  onClickForecast,
  onClickLostSales,
}) => {
  const { openForecast } = useForecast();
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handlePopoverClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const handleActionClick = (action, e) => {
    handlePopoverClose(e);
    switch (action) {
      case "track":
        handleTrackInventory(x);
        break;

      default:
        break;
    }
  };

  return (
    <Box>
      <IconButton
        aria-label="more actions"
        onClick={(e) => {
          handlePopoverOpen(e);
        }}
        sx={{
          color: open ? "primary.main" : "inherit",
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", padding: 1 }}>
          <Button
            style={{
              justifyContent: "flex-start",
              textTransform: "none",
            }}
            aria-label="delete"
            onClick={(e) => {
              e.stopPropagation();
              handleActionClick("track", e);
              // navigate(`/asn-tracking/${selectedAsn._id}`)
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <OrderTrackingIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                fontWeight={500}
                color={"var(--text-tertiary)"}
              >
                Track
              </Typography>
            </Box>
          </Button>
          <Button
            style={{
              justifyContent: "flex-start",
              textTransform: "none",
            }}
            aria-label="lost-sales"
            onClick={(e) => {
              e.stopPropagation();
              handlePopoverClose(e);
              onClickLostSales(x);
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <ForecastIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                fontWeight={500}
                color={"var(--text-tertiary)"}
              >
                Lost Sales
              </Typography>
            </Box>
          </Button>
          <Button
            style={{
              justifyContent: "flex-start",
              textTransform: "none",
            }}
            aria-label="forecast"
            onClick={(e) => {
              e.stopPropagation();
              onClickForecast(x);
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <ForecastIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                fontWeight={500}
                color={"var(--text-tertiary)"}
              >
                Forecast
              </Typography>
            </Box>
          </Button>
          <Button
            style={{
              justifyContent: "flex-start",
              textTransform: "none",
            }}
            aria-label="forecast-history"
            onClick={(e) => {
              e.stopPropagation();
              handlePopoverClose(e);
              handleOpenForecastHistory(x);
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <ForecastIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                fontWeight={500}
                color={"var(--text-tertiary)"}
              >
                History
              </Typography>
            </Box>
          </Button>
        </Box>
      </Popover>
    </Box>
  );
};
const InventoryList = ({
  viewMode,
  data,
  setPage,
  setRowsPerPage,
  rowsPerPage,
  page,
  dataCount,
  selectedInventory,
  setSelectedInventory,
  filterData,
  onChangeFilter,
  setLoading,
  loading,
  fetchInventory,
  selectedInventories,
  setSelectedInventories,
  setForecastDialogOpen,
  client_id,
}) => {
  const [inventoryData, setInventoryData] = useState([]);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);
  const [lotList, setLotList] = useState([]);
  const [lotLoading, setLotLoading] = useState(false);
  const [lotCount, setLotCount] = useState(0);
  const [lotPage, setLotPage] = useState(0);
  const [lotRowsPerPage, setLotRowsPerPage] = useState(5);
  const scrollRef = useRef();
  const expandedRef = useRef();
  const tableContainerRef = useRef();
  const defaultColor = "#D13438";
  const theme = useTheme();
  const startIndex = rowsPerPage * page;
  const navigate = useNavigate();
  const primary_color = theme.palette?.primary?.main || defaultColor;
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const [selectedfilterData, setSelectedFilterData] = useState({
    key: "",
    name: "",
    filter: [],
    sort: 0,
    id: "_id",
    displayKey: "sku",
    fetchApi: () => {},
    loadMoreButton: false,
    options: [],
    searchKey: "",
  });
  const [openForecastHistoryModal, setOpenForecastHistoryModal] =
    useState(false);
  const [forecastHistoryData, setForecastHistoryData] = useState([]);
  const [forecastHistoryLoading, setForecastHistoryLoading] = useState(false);
  const [selectedForecastItem, setSelectedForecastItem] = useState(null);
  const [displayExplanation, setDisplayExplanation] = useState(false);
  const { openForecastParamsModal } = useForecast();
  const { openLostSalesParams } = useLostSales();

  const handleTrackInventory = (selectedItem) => {
    navigate(
      `/asn-tracking/${encodeURIComponent(selectedItem.sku)}?inventory=true`,
    );
  };
  const handleOpenFilter = (event, filterKey) => {
    setAnchorElFilter(event.currentTarget);
    setOpenFilterModal(true);
    setSelectedFilterData(filterData?.columns?.find((x) => x.key == filterKey));
  };
  const handleSaveFilter = (
    selectedOptions,
    filterKey,
    sortOrder,
    searchKey,
  ) => {
    onChangeFilter({
      key: filterKey,
      filter: selectedOptions,
      sort: sortOrder,
      searchKey: searchKey,
    });

    handleCloseFilter();
  };

  const onClickForecast = (item) => {
    openForecastParamsModal([item], {
      onRefresh: fetchInventory,
      onClearSelected: () => setSelectedInventories([]),
    });
  };

  const onClickLostSales = (item) => {
    openLostSalesParams(item);
  };

  const handleCloseFilter = () => {
    setAnchorElFilter(null);
    setOpenFilterModal(false);
  };

  const handleOpenForecastHistory = async (item) => {
    setSelectedForecastItem(item);
    setOpenForecastHistoryModal(true);
    setForecastHistoryLoading(true);
    try {
      const response = await inventoryService.fetchForecastHistory(
        item.client?._id || item.client,
        item.sku,
      );
      const res = await staticDataService.fetchByType(
        "SHOW_FORECAST_EXPLANATION",
      );
      if (res.data.length > 0) {
        setDisplayExplanation(res.data[0].value);
      }
      setForecastHistoryData(response.data || []);
    } catch (error) {
      console.error("Error fetching forecast history:", error);
      setForecastHistoryData([]);
    } finally {
      setForecastHistoryLoading(false);
    }
  };

  const handleCloseForecastHistory = () => {
    setOpenForecastHistoryModal(false);
    setForecastHistoryData([]);
  };

  const fetchLots = async (inventoryId, page = 0, limit = lotRowsPerPage) => {
    setLotLoading(true);
    setLotList([]);
    try {
      const response = await lotService.fetchByInventory(
        inventoryId,
        page,
        limit,
      );
      setLotList(response.data || []);
      setLotCount(response.total || 0);
    } catch (error) {
      console.error("Lot fetch failed:", error);
      setLotList([]);
      setLotCount(0);
    } finally {
      setLotLoading(false);
    }
  };

  const handleRestoreForecast = async (forecastItem) => {
    await inventoryService.edit(selectedForecastItem._id, {
      reorder_point: Math.round(forecastItem.metrics.reorder_point),
      next_reorder_date: forecastItem.metrics.reorder_by_date,
    });
    toast.success("Inventory restored to forecast values successfully");
    fetchInventory();
  };

  useEffect(() => {
    setInventoryData(
      data?.map((x) => ({
        ...x,
        action: (
          <DropskipToolTableCell
            x={x}
            handleTrackInventory={handleTrackInventory}
            handleOpenForecastHistory={handleOpenForecastHistory}
            onClickForecast={onClickForecast}
            onClickLostSales={onClickLostSales}
          />
        ),
      })),
    );
  }, [data]);

  useEffect(() => {
    const handleScroll = () => {
      if (expandedRow && expandedRef.current && tableContainerRef.current) {
        const containerRect = tableContainerRef.current.getBoundingClientRect();
        const expandedRect = expandedRef.current.getBoundingClientRect();
        const relativeTop = expandedRect.top - containerRect.top;
        if (relativeTop < 100) {
          // threshold to close before overlapping header
          setExpandedRow(null);
        }
      }
    };

    const scrollElement = tableContainerRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
      return () => scrollElement.removeEventListener("scroll", handleScroll);
    }
  }, [expandedRow]);

  const renderGridView = () => (
    <Grid
      sx={{
        marginTop: "1px",
        maxHeight: "100%",
        paddingBottom: 5,
        overflow: "auto",
      }}
      container
      spacing={2}
    >
      {inventoryData?.map((x, index) => (
        <Grid
          sx={{ paddingBottom: 1 }}
          item
          xs={12}
          sm={6}
          md={4}
          key={x._id + "-inventory-list-grid-" + index}
        >
          <Card
            sx={{
              boxShadow: 3,
              cursor: "pointer",
              width: "100%",
              height: "100%",
              position: "relative",
              borderRadius: "6px",
              border: "1px solid var(--border-color)",
            }}
          >
            <CardContent>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  fontWeight="500"
                  sx={{ textAlign: "start" }}
                  fontFamily="Poppins"
                  color="var(--text-tertiary)"
                >
                  {startIndex + index + 1}
                </Typography>
                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                  }}
                >
                  {x?.action}
                </div>
              </div>
              <Grid container spacing={1} mt={1}>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Product Name
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    : {x?.product?.name}
                  </Typography>
                </Grid>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="var(--text-tertiary)"
                  >
                    SKU
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    : {x?.sku}
                  </Typography>
                </Grid>

                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Warehouse
                  </Typography>
                </Grid>
                {/* <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    : {x?.warehouse_cde || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Warehouse Code
                  </Typography>
                </Grid> */}
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    :{" "}
                    {x?.warehouse?.warehouse_id ||
                      x?.warehouse?.warehouse_code ||
                      "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    On Hand
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    : {x?.in_hand}
                  </Typography>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Committed
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    : {x?.in_transit || "--"}
                  </Typography>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    {`Reorder Threshold`}
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    : {x?.reorder_point || "--"}
                  </Typography>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Next Reorder Date
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    :{" "}
                    {x?.next_reorder_date
                      ? formatDate(x?.next_reorder_date)
                      : "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Last Forecast Date
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    :{" "}
                    {x?.last_forecast_date
                      ? formatDate(x?.last_forecast_date)
                      : "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Last PO Date
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    :{" "}
                    {x?.last_po_created_date
                      ? formatDate(x?.last_po_created_date)
                      : "N/A"}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const TableSchema = [
    {
      key: "selection",
      title: "",
      renderTitle: () => (
        <Checkbox
          // sx={
          //   {
          //     pt: 0.5,
          //   }
          // }
          checked={
            inventoryData?.length > 0 &&
            selectedInventories?.length === inventoryData?.length
          }
          onChange={() => {
            if (selectedInventories?.length === inventoryData?.length) {
              setSelectedInventories([]);
            } else {
              setSelectedInventories(inventoryData);
            }
          }}
        />
      ),
      render: (item) => (
        <Checkbox
          checked={Boolean(
            selectedInventories.find((inv) => inv._id === item._id),
          )}
          onChange={() => {
            if (selectedInventories.find((inv) => inv._id === item._id)) {
              setSelectedInventories((prev) => {
                const newSelected = prev.filter((inv) => inv._id !== item._id);
                return newSelected;
              });
            } else {
              setSelectedInventories((prev) => [...prev, item]);
            }
          }}
          onClick={(e) => e.stopPropagation()}
        />
      ),
    },
    {
      key: "sl_no",
      title: "Sl No",
      render: (item, index) => (
        <Typography
          fontSize="12px"
          color="#667085"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {startIndex + index + 1}
        </Typography>
      ),
    },
    {
      key: "product",
      title: "Product Name",
      handleOpenFilter: handleOpenFilter,
      render: (item) => (
        <Hover title={item?.product?.name}>
          <Typography
            fontSize="12px"
            color="var(--text-secondary)"
            fontWeight={400}
            fontFamily={"Poppins"}
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "150px",
              display: "block",
            }}
          >
            {item?.product?.name}
          </Typography>
        </Hover>
      ),
    },
    {
      key: "sku",
      title: "SKU",
      handleOpenFilter: handleOpenFilter,
      displayKey: "sku",
    },
    ...(client_id
      ? []
      : [
          {
            key: "client",
            title: "CLIENT",
            handleOpenFilter,
            render: (item) => (
              <Typography
                fontSize="12px"
                color="var(--text-secondary)"
                fontWeight={400}
                fontFamily="Poppins"
              >
                {item?.client?.business_name || "--"}
              </Typography>
            ),
          },
        ]),
    {
      key: "warehouse",
      title: "Warehouse",
      handleOpenFilter: handleOpenFilter,
      render: (item) => (
        <Typography
          fontSize="12px"
          color="#667085"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {item?.warehouse?.warehouse_id ||
            item?.warehouse?.warehouse_code ||
            "N/A"}
        </Typography>
      ),
    },
    {
      key: "in_hand",
      title: "On Hand",
      handleOpenFilter: handleOpenFilter,
      displayKey: "in_hand",
    },
    {
      key: "in_transit",
      title: "Committed",
      handleOpenFilter: handleOpenFilter,
      displayKey: "in_transit",
    },
    {
      key: "reorder_point",
      title: "Reorder Threshld",
      handleOpenFilter: handleOpenFilter,
      displayKey: "reorder_point",
    },
    {
      key: "next_reorder_date",
      title: "Reorder Date",
      handleOpenFilter: handleOpenFilter,
      render: (item) => (
        <Typography
          fontSize="12px"
          color="#667085"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {item?.next_reorder_date
            ? formatDate(item?.next_reorder_date)
            : "N/A"}
        </Typography>
      ),
    },
    {
      key: "last_forecast_date",
      title: "Last Forecast Date",
      handleOpenFilter: handleOpenFilter,
      render: (item) => (
        <Typography
          fontSize="12px"
          color="#667085"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {item?.last_forecast_date
            ? formatDate(item?.last_forecast_date)
            : "N/A"}
        </Typography>
      ),
    },
    {
      key: "last_po_created_date",
      title: "Last PO Date",
      handleOpenFilter: handleOpenFilter,
      render: (item) => (
        <Typography
          fontSize="12px"
          color="#667085"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {item?.last_po_created_date
            ? formatDate(item?.last_po_created_date)
            : "N/A"}
        </Typography>
      ),
    },
    // {
    //   key: "ACTUAL vs FORECAST",
    //   title: "ACTUAL vs FORECAST",
    //   render: (item, index) => <ChartCell index={index} item={item} />,
    // },
    { key: "action", title: "", displayKey: "action" },
  ];

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        overflow: isMobile() ? "auto" : "hidden",
      }}
    >
      <TableContainer
        ref={tableContainerRef}
        sx={{
          overflowY: "auto",
          // paddingInline: 0.4,
          maxHeight: "100%",
        }}
      >
        <Table
          stickyHeader
          aria-label="sticky table"
          sx={{
            border: "1px solid var(--border-color)",
          }}
        >
          <TableHead>
            <StyledTableRow>
              {TableSchema.map((column) => (
                <TableHeader
                  filterData={filterData}
                  primary_color={primary_color}
                  handleOpenFilter={column.handleOpenFilter}
                  key={column.key}
                  filterKey={column.key}
                  title={column.title}
                  renderTitle={column.renderTitle}
                />
              ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {loading
              ? [...Array(rowsPerPage || 15)].map((_, ri) => (
                  <TableRow key={ri}>
                    {TableSchema.map((col, ci) => (
                      <TableCell key={ci} sx={{ p: 1 }}>
                        <Skeleton variant="text" />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              : inventoryData?.map((x, index) => (
                  <React.Fragment key={x._id + "-inventory-list-" + index}>
                    <StyledTableRow
                      sx={{ cursor: "pointer" }}
                      isExpandable={expandedRow === x._id}
                      onClick={() => {
                        if (expandedRow === x._id) {
                          setExpandedRow(null);
                        } else {
                          setExpandedRow(x._id);
                          setLotPage(0);
                          setLotCount(0);
                          fetchLots(x._id, 0);
                        }
                      }}
                      key={x._id}
                    >
                      {TableSchema.map((column) => (
                        <StyledTableCell>
                          {column.displayKey ? (
                            <Typography
                              fontSize="12px"
                              color="var(--text-secondary)"
                              fontWeight={400}
                              fontFamily={"Poppins"}
                            >
                              {/* ?? not || — a real 0 must not render as "--",
                                  which reads as "no data". */}
                              {x[column.displayKey] ?? "--"}
                            </Typography>
                          ) : column.render ? (
                            column.render(x, index)
                          ) : null}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                    {expandedRow === x._id && (
                      <TableRow
                        ref={expandedRef}
                        key={x._id}
                        sx={{ backgroundColor: "var(--row-bg-odd)" }}
                      >
                        <TableCell style={{ width: "100%" }} colSpan={12}>
                          <Collapse
                            in={expandedRow === x._id}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Box marginBottom={2} marginTop={1} ml={2}>
                              <Typography
                                fontSize="14px"
                                fontWeight={500}
                                color="var(--text-tertiary)"
                                fontFamily={"poppins"}
                              >
                                Lot Details:
                              </Typography>

                              <TableContainer
                                sx={{
                                  maxHeight: "400px",
                                  overflowY: "auto",
                                  border: "1px solid var(--border-color)",
                                }}
                              >
                                <Table
                                  stickyHeader
                                  sx={{
                                    border: "1px solid var(--border-color)",
                                  }}
                                >
                                  <TableHead sx={{ zIndex: -10 }}>
                                    <TableRow>
                                      <TableCell
                                        sx={{
                                          width: "20%",
                                          borderRight:
                                            "1px solid var(--border-color)",
                                        }}
                                      >
                                        <Typography
                                          fontSize="14px"
                                          color="var(--text-tertiary)"
                                          fontWeight={500}
                                          fontFamily={"poppins"}
                                        >
                                          PO No
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          width: "20%",
                                          borderRight:
                                            "1px solid var(--border-color)",
                                        }}
                                      >
                                        <Typography
                                          fontSize="14px"
                                          color="var(--text-tertiary)"
                                          fontWeight={500}
                                          fontFamily={"poppins"}
                                        >
                                          PO Receive Date
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          width: "20%",
                                          borderRight:
                                            "1px solid var(--border-color)",
                                        }}
                                      >
                                        <Typography
                                          fontSize="14px"
                                          color="var(--text-tertiary)"
                                          fontWeight={500}
                                          fontFamily={"poppins"}
                                        >
                                          No of Overpacks
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          width: "20%",
                                          borderRight:
                                            "1px solid var(--border-color)",
                                        }}
                                      >
                                        Overpack Type
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          width: "20%",
                                          borderRight:
                                            "1px solid var(--border-color)",
                                        }}
                                      >
                                        <Typography
                                          fontSize="14px"
                                          color="var(--text-tertiary)"
                                          fontWeight={500}
                                          fontFamily={"poppins"}
                                        >
                                          Items/Overpack
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          width: "20%",
                                          borderRight:
                                            "1px solid var(--border-color)",
                                        }}
                                      >
                                        <Typography
                                          fontSize="14px"
                                          color="var(--text-tertiary)"
                                          fontWeight={500}
                                          fontFamily={"poppins"}
                                        >
                                          Total
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {lotLoading ? (
                                      [...Array(3)].map((_, ri) => (
                                        <TableRow key={"lot-skeleton-" + ri}>
                                          {[...Array(6)].map((__, ci) => (
                                            <TableCell key={ci}>
                                              <Skeleton variant="text" />
                                            </TableCell>
                                          ))}
                                        </TableRow>
                                      ))
                                    ) : lotList.length === 0 ? (
                                      <TableRow>
                                        <TableCell colSpan={6} align="center">
                                          <Typography
                                            fontSize="12px"
                                            color="var(--text-secondary)"
                                            fontWeight={400}
                                            fontFamily={"Poppins"}
                                          >
                                            No lots found
                                          </Typography>
                                        </TableCell>
                                      </TableRow>
                                    ) : (
                                      lotList.map((item, index) => (
                                        <TableRow key={index}>
                                          <TableCell
                                            sx={{
                                              borderRight:
                                                "1px solid var(--border-color)",
                                            }}
                                          >
                                            <Typography
                                              fontSize="12px"
                                              color="var(--text-secondary)"
                                              fontWeight={400}
                                              fontFamily={"Poppins"}
                                            >
                                              {item.po_no || "--"}
                                            </Typography>
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              borderRight:
                                                "1px solid var(--border-color)",
                                            }}
                                          >
                                            <Typography
                                              fontSize="12px"
                                              color="var(--text-secondary)"
                                              fontWeight={400}
                                              fontFamily={"Poppins"}
                                            >
                                              {item.date
                                                ? formatDate(item.date)
                                                : formatDate(new Date())}
                                            </Typography>
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              borderRight:
                                                "1px solid var(--border-color)",
                                            }}
                                          >
                                            <Typography
                                              fontSize="12px"
                                              color="var(--text-secondary)"
                                              fontWeight={400}
                                              fontFamily={"Poppins"}
                                            >
                                              {item.no_of_overpack}
                                            </Typography>
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              borderRight:
                                                "1px solid var(--border-color)",
                                            }}
                                          >
                                            <Typography
                                              fontSize="12px"
                                              color="var(--text-secondary)"
                                              fontWeight={400}
                                              fontFamily={"Poppins"}
                                            >
                                              {item.overpack_type}
                                            </Typography>
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              borderRight:
                                                "1px solid var(--border-color)",
                                            }}
                                          >
                                            <Typography
                                              fontSize="12px"
                                              color="var(--text-secondary)"
                                              fontWeight={400}
                                              fontFamily={"Poppins"}
                                            >
                                              {item.items_per_overpack}
                                            </Typography>
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              borderRight:
                                                "1px solid var(--border-color)",
                                            }}
                                          >
                                            <Typography
                                              fontSize="12px"
                                              color="var(--text-secondary)"
                                              fontWeight={400}
                                              fontFamily={"Poppins"}
                                            >
                                              {item.quantity}
                                            </Typography>
                                          </TableCell>
                                        </TableRow>
                                      ))
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              {lotCount > 0 && (
                                <TablePagination
                                  component="div"
                                  count={lotCount}
                                  page={lotPage}
                                  rowsPerPage={lotRowsPerPage}
                                  rowsPerPageOptions={[5, 10, 25]}
                                  showFirstButton
                                  showLastButton
                                  onPageChange={(event, newPage) => {
                                    setLotPage(newPage);
                                    fetchLots(x._id, newPage, lotRowsPerPage);
                                  }}
                                  onRowsPerPageChange={(event) => {
                                    const newLimit = parseInt(
                                      event.target.value,
                                      10,
                                    );
                                    setLotRowsPerPage(newLimit);
                                    setLotPage(0);
                                    fetchLots(x._id, 0, newLimit);
                                  }}
                                  sx={{
                                    border: "1px solid var(--border-color)",
                                    borderTop: "none",
                                    color: "var(--text-secondary)",
                                    ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                                      {
                                        fontSize: "12px",
                                        fontFamily: "Poppins",
                                        marginBottom: 0,
                                      },
                                  }}
                                />
                              )}
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );

  return (
    <div sx={{ minWidth: "100%" }}>
      <div
        ref={scrollRef}
        style={{
          overflowY: "scroll",
          display: "flex",
          maxHeight: isMobile() ? `calc(100vh - 200px)` : `calc(100vh - 270px)`,
          width: "100%",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::WebkitScrollbar": { width: 0 },
        }}
      >
        {viewMode === "grid" || isMobile()
          ? renderGridView()
          : renderListView()}
      </div>
      <Pagination
        dataCount={dataCount}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= rowsPerPage * (page + 1)}
      />
      <Popover
        open={Boolean(anchorElFilter)}
        anchorEl={anchorElFilter}
        onClose={handleCloseFilter}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        disableScrollLock={true}
      >
        <FilterModal
          open={openFilterModal}
          onClose={handleCloseFilter}
          options={selectedfilterData?.options}
          selectedValues={selectedfilterData?.filter}
          onSave={handleSaveFilter}
          currentSortOrder={selectedfilterData?.sort}
          filterKey={selectedfilterData?.key}
          hasMore={selectedfilterData?.loadMoreButton}
          displayKey={selectedfilterData?.displayKey}
          id={selectedfilterData?.id}
          fetchApi={selectedfilterData?.fetchApi}
          searchKey={selectedfilterData?.searchKey}
          type={selectedfilterData?.type}
        />
      </Popover>
      <InventoryDetailsModal
        inventory={selectedInventory}
        open={openViewModal}
        onClose={() => setOpenViewModal(false)}
      />
      <ForecastHistoryModal
        open={openForecastHistoryModal}
        onClose={handleCloseForecastHistory}
        forecastHistory={forecastHistoryData}
        onRestore={handleRestoreForecast}
        loading={forecastHistoryLoading}
        sku={selectedForecastItem?.sku}
        displayExplanation={displayExplanation}
      />
    </div>
  );
};

export default InventoryList;
